import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-setting_time",
  "use": "icon-setting_time-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol viewBox=\"0 0 16 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-setting_time\">\n<path d=\"M8.00131 2.92969C4.68809 2.92969 2 5.61777 2 8.93099C2 12.2442 4.68809 14.9323 8.00131 14.9323C11.3145 14.9323 14.0026 12.2442 14.0026 8.93099C14.0026 5.61777 11.3145 2.92969 8.00131 2.92969Z\" stroke-width=\"1.00189\" stroke-miterlimit=\"10\" />\n<path d=\"M8.00195 4.92969V9.43131H11.003\" stroke-width=\"1.00189\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol